import {
  fetchData
} from './ajax'
//登录页面
export function interOutnetConfig (data, type, callFunc) {
  var msg = data
  if (callFunc && (callFunc.constructor === Function)) {
    return fetchData('/ApprNetInterface/api/sys/outnetConfig/query.v', msg, type, callFunc)
  }
  return fetchData('/ApprNetInterface/api/sys/outnetConfig/query.v', msg, type)
}
// 获取某个预约业务可预约的日期时间段列表
export function getReserveDate (data, type, callFunc) {
  var msg = data
  if (callFunc && (callFunc.constructor === Function)) {
    return fetchData('/ApprReserveInterface/api/reserve/reserveDateList/query.v', msg, type, callFunc)
  }
  return fetchData('/ApprReserveInterface/api/reserve/reserveDateList/query.v', msg, type)
}

// 获取可预约单列表（包含二级单位）
export function getUnitTreeList (data, type, callFunc) {
  var msg = data
  if (callFunc && (callFunc.constructor === Function)) {
    return fetchData('/ApprReserveInterface/api/reserve/unitTreeList/query.v', msg, type, callFunc)
  }
  return fetchData('/ApprReserveInterface/api/reserve/unitTreeList/query.v', msg, type)
}

// 获取可预约业务列表（包含二级业务）
export function getReserveTreeList (data, type, callFunc) {
  var msg = data
  if (callFunc && (callFunc.constructor === Function)) {
    return fetchData('/ApprReserveInterface/api/reserve/reserveTreeList/query.v', msg, type, callFunc)
  }
  return fetchData('/ApprReserveInterface/api/reserve/reserveTreeList/query.v', msg, type)
}

// 获取预约业务规则说明列表
export function getReserveRuleInfo (data, type, callFunc) {
  var msg = data
  if (callFunc && (callFunc.constructor === Function)) {
    return fetchData('/ApprReserveInterface/api/reserve/reserveRuleInfo/query.v', msg, type, callFunc)
  }
  return fetchData('/ApprReserveInterface/api/reserve/reserveRuleInfo/query.v', msg, type)
}

// 提交预约信息接口
export function ReserveInfoAdd (data, type, callFunc) {
  var msg = data
  if (callFunc && (callFunc.constructor === Function)) {
    return fetchData('/ApprReserveInterface/api/reserve/reserveInfo/add.v', msg, type, callFunc)
  }
  return fetchData('/ApprReserveInterface/api/reserve/reserveInfo/add.v', msg, type)
}

// 获取大厅信息列表
export function hallInfoList (data, type, callFunc) {
  var msg = data
  if (callFunc && (callFunc.constructor === Function)) {
    return fetchData('/ApprNetInterface/api/hall/hallInfoList/query.v', msg, type, callFunc)
  }
  return fetchData('/ApprNetInterface/api/hall/hallInfoList/query.v', msg, type)
}
// ********我的预约*********
// 获取预约信息列表
export function interApprReserveInfoList (data, type, callFunc) {
  var msg = data
  if (callFunc && (callFunc.constructor === Function)) {
    return fetchData('/ApprReserveInterface/api/reserve/reserveInfoList/query.v', msg, type, callFunc)
  }
  return fetchData('/ApprReserveInterface/api/reserve/reserveInfoList/query.v', msg, type)
}
// 取消预约-->取消某个预约
export function interReserveInfoCancel (data, type, callFunc) {
  var msg = data
  if (callFunc && (callFunc.constructor === Function)) {
    return fetchData('/ApprReserveInterface/api/reserve/reserveInfo/cancel/update.v', msg, type, callFunc)
  }
  return fetchData('/ApprReserveInterface/api/reserve/reserveInfo/cancel/update.v', msg, type)
}
// 删除预约-->删除某个预约信息
export function interReserveInfoDelete (data, type, callFunc) {
  var msg = data
  if (callFunc && (callFunc.constructor === Function)) {
    return fetchData('/ApprReserveInterface/api/reserve/reserveInfo/delete.v', msg, type, callFunc)
  }
  return fetchData('/ApprReserveInterface/api/reserve/reserveInfo/delete.v', msg, type)
}
//获取网厅用户信息接口
export function interOutUserInfo (data, type, callFunc) {
  return fetchData('/ApprNetUserInterface/api/user/outUserInfo/query.v', data, type, callFunc)
}
// 预约2.0新增接口
// 获取服务类型接口
export function interSt (data, type, callFunc) {
  return fetchData('/ApprReserveInterface/api/nr/st/query.v', data, type, callFunc)
}
// 获取业务类型接口
export function interBs (data, type, callFunc) {
  return fetchData('/ApprReserveInterface/api/nr/bs/query.v', data, type, callFunc)
}
// 获取业务绑定的事项列表
export function interBsi (data, type, callFunc) {
  return fetchData('/ApprReserveInterface/api/nr/bsi/query.v', data, type, callFunc)
}
// 获取业务可选大厅
export function interHall (data, type, callFunc) {
  return fetchData('/ApprReserveInterface/api/nr/hall/query.v', data, type, callFunc)
}
// 根据地区主键获取地区和子地区
export function interArea (data, type, callFunc) {
  return fetchData('/ApprReserveInterface/api/nr/area/query.v', data, type, callFunc)
}
// 我的预约列表
export function myAppointmentList (data, type, callFunc) {
  return fetchData('/ApprReserveInterface/api/nr/myrs/query.v', data, type, callFunc)
}
// 预约删除
export function delAppointment (data, type, callFunc) {
  return fetchData('/ApprReserveInterface/api/nr/del/update.v', data, type, callFunc)
}
// 预约取消
export function cancleAppointment (data, type, callFunc) {
  return fetchData('/ApprReserveInterface/api/nr/cc/update.v', data, type, callFunc)
}
// 预约改期
export function changeAppointment (data, type, callFunc) {
  return fetchData('/ApprReserveInterface/api/nr/ct/update.v', data, type, callFunc)
}
// 获取预约日期
export function appointmentDate (data, type, callFunc) {
  return fetchData('/ApprReserveInterface/api/nr/date/query.v', data, type, callFunc)
}
// 获取预约时间
export function appointmentTime (data, type, callFunc) {
  return fetchData('/ApprReserveInterface/api/nr/time/query.v', data, type, callFunc)
}
//提交预约
export function submitAppointment (data, type, callFunc) {
  return fetchData('/ApprReserveInterface/api/nr/submit/add.v', data, type, callFunc)
}
// 信息补充接口
export function supplementUpdate (data, type, callFunc) {
  return fetchData('/ApprReserveInterface/api/nr/bc/update.v', data, type, callFunc)
}
// 根据预约信息获取办件列表
export function getControlInfoByBusSeq (data, type, callFunc) {
  return fetchData('/CommonService/api/control/getControlInfoByBusSeq/query', data, type, callFunc)
}
// 预约服务规则查询
export function serviceRule(data, type, callFunc) {
  return fetchData('/ApprReserveInterface/api/nr/sr/query.v', data, type, callFunc)
}

// 预约v2.1.0
// 获取预约服务配置信息
export function getConfigurationInformation (data, type, callFunc) {
  return fetchData('/ApprReserveInterface/api/nr/rbc/query.v', data, type, callFunc)
}
// 获取服务大厅接口（常规）
export function getHallList (data, type, callFunc) {
  return fetchData('/ApprReserveInterface/api/nr/fhl/query.v', data, type, callFunc)
}
// 获取单位列表接口
export function getUnitList (data, type, callFunc) {
  return fetchData('/ApprReserveInterface/api/nr/unit/query.v', data, type, callFunc)
}
// 获取服务大厅类型接口
export function getServiceTypeList (data, type, callFunc) {
  return fetchData('/ApprReserveInterface/api/nr/st/query.v', data, type, callFunc)
}
// 获取地区筛选树（常规预约-镇街-村居）
export function getScreeningTree1 (data, type, callFunc) {
  return fetchData('/ApprReserveInterface/api/nr/at/query.v', data, type, callFunc)
}
// 获取地区筛选树
export function getScreeningTree2 (data, type, callFunc) {
  return fetchData('/ApprReserveInterface/api/nr/apt/query.v', data, type, callFunc)
}
// 根据事项编码获取事项信息
export function getApprItem (data, type, callFunc) {
  return fetchData('/ApprReserveInterface/api/item/getApprItem/query.v', data, type, callFunc)
}
// 获取大厅配置温馨提示
export function getHallNotice (data, type, callFunc) {
  return fetchData('/ApprReserveInterface/api/nr/hallConfig/query.v', data, type, callFunc)
}
// 根据大厅主键以及事项编码获取业务相关信息
export function getMsgByHallAndItem (data, type, callFunc) {
  return fetchData('/ApprReserveInterface/api/hp/reserve/checkRadarSkip.v', data, type, callFunc)
}